import { createApp } from 'vue';
import App from './App.vue';
import PageAccueil from './components/PageAccueil.vue';
import PageModele from './components/PageModele.vue';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import Tooltip from 'primevue/tooltip';
import { createRouter, createWebHistory } from 'vue-router';
import Keycloak from 'keycloak-js';
import { setInstanceKeycloak } from '@/services/keycloakService';

import 'primevue/resources/primevue.min.css'
import 'primevue/resources/themes/lara-light-blue/theme.css'
import 'primeicons/primeicons.css'

import './assets/main.css';

const routes = [
    { path: '/', component: PageAccueil },
    { path: '/modeles/:idModele', component: PageModele }
  ];

const router = createRouter({
    history: createWebHistory(),
    routes: routes,
  });

async function demarrerApp() {
  try {
    const response = await fetch('/api/config');
    const config = await response.json();
    console.log("Config chargée depuis le serveur:", config);
    const keycloak = new Keycloak({
      url: config.keycloakUrl,
      realm: 'modalink',
      clientId: 'modalink-web'
    });
    await keycloak.init({ onLoad: 'login-required' });
    console.log("Utilisateur authentifié avec succès !");
    
    // L'utilisateur est connecté, on peut maintenant initialiser et afficher l'application Vue
    const app = createApp(App);

    // On rend keycloak accessible partout dans l'app si besoin
    setInstanceKeycloak(keycloak);

    app.use(router);
    app.use(PrimeVue);
    app.use(ToastService);
    app.directive('tooltip', Tooltip);

    app.mount('#app');

  } catch (error) {
    console.error("Impossible de démarrer l'application :", error);
  }
}

demarrerApp();
